type AudienceConnectionState = {
  timestamp: Date | null;
  status:
    | "audienceConnectionTestSucceeded"
    | "audienceConnectionTestFailed"
    | "audienceConnectionTestUnknown";
  audienceAlias: string;
  error: string | null;
};

function isAudienceConnectionState(
  settings?: Record<string, any>,
): settings is AudienceConnectionState {
  if (!settings || typeof settings !== "object") {
    return false;
  }

  const hasFields =
    "timestamp" in settings &&
    "status" in settings &&
    "audienceAlias" in settings &&
    "error" in settings;

  const hasValidTimestamp = !isNaN(new Date(settings.timestamp).getTime());
  const hasValidStatus = [
    "audienceConnectionTestSucceeded",
    "audienceConnectionTestFailed",
    "audienceConnectionTestUnknown",
  ].includes(settings.status);

  return hasFields && hasValidTimestamp && hasValidStatus;
}

export function audienceConnectionStateFromSettings(
  settings: Record<string, any>,
): AudienceConnectionState | null {
  if (
    !settings ||
    typeof settings !== "object" ||
    !("audienceConnectionState" in settings)
  ) {
    return null;
  }

  if (!isAudienceConnectionState(settings.audienceConnectionState)) {
    return null;
  }

  return {
    timestamp:
      settings.audienceConnectionState.timestamp !== null
        ? new Date(settings.audienceConnectionState.timestamp)
        : null,
    status: settings.audienceConnectionState.status,
    audienceAlias: settings.audienceConnectionState.audienceAlias,
    error: settings.audienceConnectionState.error ?? null,
  };
}
